import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class DocumentAPI {

  static getInnerList = (modelType, modelId, success, failure) => {
    const page = 1;
    const perPage = 100;
    const body = {
      filter: [{
        field: 'model', type: 'model', condition: 'equals',
        value: `${modelType}~${modelId}`
      }], page, perPage
    };
    fetch(Config.app.link + 'api/document/list', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/document/' + id, new Header('GET'))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };

  static save = (doc, success, failure) => {
    new Promise(async (resolve, reject) => {
      const medias = [];
      const model_no = doc.model_no;
      const model_id = doc.model_id;
      if (doc.files && doc.files.length > 0) {
        for (let i = 0; i < doc.files.length; i++) {
          let type = doc.files[i].name;
          type = type.lastIndexOf('.') !== -1 ? type.substring(type.lastIndexOf('.') + 1) : '';
          medias.push({ ref: i, model_no, model_id, type, link: doc?.link, size: doc.files[i].size });
        }
        const resMedias = await new Promise(resolve => {
          fetch(Config.app.link + 'api/media/put-private', new Header('POST', medias))
            .then(res => {
              if (res.status === Const.Success200) { res.json().then(result => resolve(result)); }
              else { res.json().then(er => failure(er)); }
            }).catch(er => failure(er));
        });
        let files = '';
        for (let i = 0; i < resMedias.length; i++) {
          const options = { method: 'PUT', body: doc.files[resMedias[i].ref] };
          await new Promise(resolve => {
            fetch(resMedias[i].signed, options).then(res => resolve(res));
          });
          files = files + resMedias[i].id + Const.Opt;
        }
        doc.files = Const.Opt + files;
      }
      fetch(Config.app.link + 'api/document/add-edit', new Header('POST', doc))
        .then(res => resolve(res)).catch(er => reject(er));
    })
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };
  
  static saveFeaturedImage = async (doc, success, failure) => {
    try {
      const medias = [];
      const model_no = doc.model_no;
      const model_id = doc.model_id;
      let files = '';
      if (doc.files && doc.files.length > 0) {
        for (let i = 0; i < doc.files.length; i++) {
          let type = doc.files[i].name;
          type = type.lastIndexOf('.') !== -1 ? type.substring(type.lastIndexOf('.') + 1) : '';
          medias.push({ ref: i, model_no, model_id, type, link: doc?.link, size: doc.files[i].size });
        }
        const resMedias = await new Promise(resolve => {
          fetch(Config.app.link + 'api/media/put-private', new Header('POST', medias))
            .then(res => {
              if (res.status === Const.Success200) { res.json().then(result => resolve(result)); }
              else { res.json().then(er => failure(er)); }
            }).catch(er => failure(er));
        });
        for (let i = 0; i < resMedias.length; i++) {
          const options = { method: 'PUT', body: doc.files[resMedias[i].ref] };
          await new Promise(resolve => {
            fetch(resMedias[i].signed, options).then(res => resolve(res));
          });
          files = files + resMedias[i].id + Const.Opt;
        }
        files = Const.Opt + files;
      }
      success(files);
    } catch (error) {
      failure(error);
    }
  };

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/document/delete/' + id, new Header('GET'))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };

  static getPublicMediaUrl = async id => {
    return await new Promise(resolve => {
      fetch(Config.app.link + 'api/media/get-public/' + id, new Header('GET'))
        .then(res => res.json().then(result => resolve(result)).catch(er => resolve(null)))
        .catch(er => resolve(null));
    });
  };
  static getText = async url => {
    return await new Promise(resolve => {
      fetch(url, new Header('GET')).then(res => res.text()
        .then(result => resolve(result)).catch(er => resolve(null)))
        .catch(er => resolve(null));
    });
  };
}
export default DocumentAPI;